<template>
  <b-modal
    id="switch-department"
    ref="switch-department"
    modal-class="add-member-to-department"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('department_switch_members') }}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div class="department-wrapper">
          <span class="department-title">
            {{ label.get('departments') }}
          </span>
          <ul class="department-members">
            <li
              v-for="(department, idx) in departments"
              :key="idx"
            >
              <div class="check-wrapper">
                <b-form-radio
                  v-model="selectedDepartment"
                  name="department"
                  class="custom-radio"
                  :value="department.id"
                >
                  {{ department.name }}
                </b-form-radio>
              </div>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          @click="saveChanges()"
        >
          {{ label.get('save_changes') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import MemberServices from '../../manage-team/services/MemberService';
    export default {
        name: "SwitchDepartmentComponent",
        props: {
            member: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return{
                selectedDepartment: null,
                departments: []
            }
        },
        mounted() {
          this.getDepartments();
          this.$refs['switch-department'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideSwitchDepartmentModal');
            },
            getDepartments() {
                this.departments.push({
                    id: -1,
                    name: this.label.get('no_department')
                });

                const storeDepartments = this.$store.state.companyDepartments.filter((item) => {
                    return item.id !== this.member.department_id;
                });

                this.departments.push(...storeDepartments.map((dep) => {
                    return {
                        id: dep.id,
                        name: dep.name
                    }
                }));
            },
            saveChanges() {
                if (this.selectedDepartment === null || this.selectedDepartment === undefined) {
                    return false;
                }

                this.$store.commit('showLoading');
                if(this.selectedDepartment === -1) {
                    MemberServices.deleteMemberFromDepartment({
                        user_id: this.member.id
                    }).then(() => {
                        this.$root.$emit('hideSwitchDepartmentModal', { member: this.member, department: null });
                        this.$store.commit('hideLoading');
                    }).catch((error) => {
                        this.$store.commit('hideLoading');
                    });
                } else {
                    MemberServices.addMemberToDepartment({
                        user_id: this.member.id,
                        department_id: this.selectedDepartment
                    }).then(() => {
                        const department = this.departments.filter((item) => { return item.id === this.selectedDepartment});
                        this.$root.$emit('hideSwitchDepartmentModal', { member: this.member, department: department[0] });
                        this.$store.commit('hideLoading');
                    }).catch(() => {
                        this.$store.commit('hideLoading');
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
  .modal{
     &.add-member-to-department{
      .modal-content{
        .modal-body{
          .content-wrapper{
            overflow: hidden;
          }
        }
      }
    }
  }
</style>